import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { LanguageProvider } from './i18n/LanguageContext';
import App from './App';
import { isDealerHost } from './utils/portalHost';
import './index.css';
import './styles/auth.css';
import './styles/partner.css';
import './styles/settings.css';
import './styles/earnings.css';
import './styles/offers.css';
import './styles/packages.css';
import './styles/dealer.css';

// Spec 085: the dealer host is its own portal to the visitor (tab title; the screens follow the host in App).
if (isDealerHost()) document.title = 'Garagat Dealers';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </BrowserRouter>
  </React.StrictMode>
);
